// extracted by mini-css-extract-plugin
export default {"root":"CarouselArrow-module-root-czxUk","hidden":"CarouselArrow-module-hidden-oEcTQ","prev":"CarouselArrow-module-prev-c9Rt3","next":"CarouselArrow-module-next-oCmvd"};